import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FETCH_STORES_SUCCESS } from '../actions/types';
import { formatStore } from '../helpers/storeHelpers';
var initialState = {
  loading: false,
  error: null,
  stores: {}
}; // Creates object { 691: store691, 4705: store4705 } from array [store691, store4705]

function addStoresToState(stores, storesInState) {
  return stores.reduce(function (obj, store) {
    if (!store || !store.store_id) return obj;
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, store.store_id, formatStore(store.storeinfo)));
  }, storesInState);
} // TODO: Make more efficient by not making request if store is already in state


function availabilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_STORES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        stores: addStoresToState(action.payload, state.stores)
      });

    default:
      return state;
  }
}

export default availabilityReducer;